﻿import { FC, ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';

export interface MainLayoutProps {
  currentPath: string;
  onNavigate: (path: string) => void;
  children: ReactNode;
}

export const MainLayout: FC<MainLayoutProps> = ({ currentPath, onNavigate, children }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header currentPath={currentPath} onNavigate={onNavigate} />
      <main style={{ flex: '1 0 auto' }}>
        {children}
      </main>
      <Footer onNavigate={onNavigate} />
    </div>
  );
};

